<template>
  <div class="animated fadeIn list-of-mr">
    <b-card>
      <div slot="header">Material/Service Requisition - Self Service
        <div class="card-header-actions">
          <b-form-radio-group  v-model="tblData.viewOption">
              <b-form-radio  value="Header">View Header</b-form-radio>
              <b-form-radio  value="Lines">View Line/Items</b-form-radio>
          </b-form-radio-group>                  
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-button variant="primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</b-button>
          <b-button variant="primary mr-1" @click="approvalConfirm()"><i class="fa fa-paper-plane"></i> Approval</b-button>
          <b-button variant="primary mr-1" @click="catalog()"><i class="fa fa-book"></i> Catalog Item</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-row>
              <b-col  lg="6">
                  <b-input-group >
                    <b-input-group-prepend><label>Request Number</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.requestno" placeholder="MR No.(% for wildcard)"></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="6">
                  <b-input-group >
                    <b-input-group-prepend><span class="pt-2">Request by &nbsp;</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.createby" placeholder="Request by"></b-form-input>
                  </b-input-group>
              </b-col>
            </b-row>          
            <b-input-group >
              <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
              <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
              <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
              <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend><label>Item Requested</label></b-input-group-prepend>
              <b-form-input v-model="tblData.uraian" placeholder="Item Name/Description" style="width:30% !important;"></b-form-input>
              <b-input-group-prepend><span class="pt-2 ml-1">Category</span></b-input-group-prepend>
              <b-form-input v-model="tblData.nmcategory" placeholder="Category/Group"></b-form-input>
            </b-input-group>
          <b-input-group>
              <b-input-group-prepend><label>Remark/Note</label></b-input-group-prepend>
              <b-form-input v-model="tblData.remark" placeholder="MR Note/Remark"></b-form-input>
          </b-input-group>
          <b-input-group >
            <b-input-group-prepend><label>Approval Status</label></b-input-group-prepend>
            <b-form-select v-model="tblData.statuswf" :plain="true" :options="dataList.approvalStatus"></b-form-select>
            <b-input-group-prepend><span class="p-2">Requested Item Receipt</span></b-input-group-prepend>
            <b-form-select v-model="tblData.outstand" :plain="true" :options="dataList.openStatus"></b-form-select>
            <b-input-group-append>
                <b-button class="btn btn-success ml-3" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1 mr-2" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowAttachment(data.item)" href="#"  style="padding:0 !important;">Attachment</b-dropdown-item>
          <b-dropdown-item @click="rowApproval(data.item)" href="#" style="padding:0 !important;">Approval</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
          <b-dropdown-item @click="showActionHistory(data.item)" href="#"  style="padding:0 !important;">Action Status</b-dropdown-item>
        </b-dropdown>
      </template>        
          <template v-slot:cell(requestno)="data">
            {{ data.item.requestno}}  <span v-if="data.item.barter==1" style="background-color:yellow;">&nbsp; (BARTER) &nbsp;</span>
          </template>

        <template v-slot:cell(requestdate)="data">
          {{ data.item.requestdate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(wfcomplete)="data">
          {{ data.item.wfcomplete | moment("DD MMM YYYY hh:mm:ss")}}
        </template>
        <template v-slot:cell(itemname)="data">
          {{ data.item.itemname }}
          <pre>{{data.item.description}}</pre>
        </template>
        <template v-slot:cell(quantity)="data">
          {{data.item.quantity}} &nbsp; {{data.item.invunitom}}
        </template>
        <template v-slot:cell(jasa)="data">
          <span v-if="(data.item.jasa)">Service</span>
        </template>
        <template v-slot:cell(actionstatus)="data">
                <span v-if="(data.item.actionstatus)"><b-link @click.stop="showActionHistory(data.item)">{{data.item.actionstatus}}</b-link></span>
                <span v-else >{{data.item.actionstatus}}</span>
        </template>
        <template v-slot:cell(issuccess)="data">
          <status-aprroval :dataStatus="data.item"></status-aprroval>  
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Are you sure about doing this?</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
      <b-modal v-model="showApprovalConfirm" header-bg-variant="primary"  title="Approval Form" size="lg" :centered="true" hide-footer>
          <b-row>
              <b-col md="5">
                  <b-input-group>
                      <b-input-group-prepend><label>Request Number</label></b-input-group-prepend>
                      <b-form-input v-model="model.requestno" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="4">                            
                  <b-input-group>
                      <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
                      <b-form-input v-model="model.requestdate" type="date"  disabled></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >  
          <b-input-group >
              <b-input-group-prepend><label>Description</label></b-input-group-prepend>
              <b-form-input v-model="model.remark"  readonly></b-form-input>
          </b-input-group>
          <div v-if="(this.model.send2wf==1)">
            <label>Workflow process history</label>
            <div class="report-wraper">
                <table width="100%">
                <thead>
                <tr>
                <th width="120px">Assign Date</th>
                <th width="220px">Assign To</th>
                <th width="80px">Action Take</th>
                <th >Comment</th>
                <th width="120px">Complete Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                  <td> {{row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                  <td>{{row.crewnik}} | {{row.crewname}}</td>
                  <td>{{row.actiontake}} 
                      <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p></td>
                  <td>{{row.message}}</td>
                  <td><span v-if="(row.completeddate)">{{row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")}}</span></td>
                  </tr>
                  <tr> <td colspan="5" class="subtotal"></td></tr>
                  </tbody>
                  </table>
              </div>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="primary" @click="printApproval"><i class="fa fa-print"></i> Print Approval</b-button>
                  <b-button v-if="((model.iscomplete==0) || (model.isreject==1))" variant="danger" class="ml-1" @click="showApprovalCancelConfirm=true" > <i class="fa fa-undo"></i> Cancel Approval</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
          <div no-body v-else>
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <div class="mt-3" >Selected file: <strong>{{ file ? file.name : '' }}</strong></div>   
              <b-row class="justify-content-center mt-1" v-if="(showConfirmNoFile)">
                  <label style="width:260px !important;">Send without attachment, are you sure?</label>
                    <b-form-radio-group  v-model="confirmNoFile"  class="ml-1" >
                        <b-form-radio :value="true">Yes</b-form-radio>
                        <b-form-radio :value="false">No</b-form-radio>
                    </b-form-radio-group>
              </b-row>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="primary" @click="approval"><i class="fa fa-paper-plane"></i> Send to Workflow</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
      </b-modal>
      <b-modal v-model="showApprovalCancelConfirm" title="Remove from workflow Approval Process?" :centered="true" @ok="approvalUndo">
        <p class="mb-1">The selected a row of data will be removed from Workflow?</p>
      </b-modal>
      <b-modal v-model="actionHistoryShow" header-bg-variant="primary"  title="Action History" size="lg" :centered="true" ok-only>
            <b-row>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label>Material Req. No.</label></b-input-group-prepend>
                        <b-form-input v-model="model.requestno" readonly></b-form-input>
                    </b-input-group>
                </b-col>
                  <b-col lg="6">                            
                    <b-input-group>
                        <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
                        <b-form-input v-model="model.requestdate"  disabled></b-form-input>                                        
                    </b-input-group>
                </b-col>
            </b-row >    
            <b-input-group >
                <b-input-group-prepend><label>Note/Remark</label></b-input-group-prepend>
                <b-form-input v-model="model.remark" readonly></b-form-input>
            </b-input-group>
            <div class="report-wraper">
              <table width="100%">
                <thead>
                  <tr>
                    <th width="120px">Action Date</th>
                    <th >Comment</th>
                    <th width="100px">Action By</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in actionHistory" :key="row.reqactionkey">
                    <td> {{row.actiondate | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                    <td>{{row.actiondtl}}</td>
                    <td>{{row.actionby}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

      </b-modal>
      <b-modal v-model="showAttachment" header-bg-variant="primary"  title="MR Attachment" size="lg" :centered="true" ok-only>
            <b-row>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label>Requesition(MR)No.</label></b-input-group-prepend>
                        <b-form-input v-model="model.requestno" readonly></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row >    
            <div class="report-wraper">
              <table width="100%">
                <thead>
                  <tr>
                    <th width="200px">Attached Date</th>
                    <th >File Name</th>
                    <th width="100px">Attached By</th>
                    <th width="40px">action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in attachmens" :key="row.attachmentKey">
                    <td> {{row.modified | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                    <td>                                
                        <b-link @click="attachmentDownload(row)">{{row.attchFileNm}}</b-link>
                    </td>
                    <td>{{row.createby}}</td>
                    <td>                                
                      <div class="text-center" v-if="(model.iscomplete==0)">
                      <a href="javascript:void(0)" class="text-danger" @click="delAttachment(row)">
                          <i class="fa fa-trash"></i>
                      </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          <div no-body v-if="(model.iscomplete==0)">
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <b-row class="mt-1" >
                  <span class="p-2" >Selected file: <strong>{{ file ? file.name : '' }}</strong></span>   
                  <b-button variant="success" @click="attachmentSave" class="sm" v-if="(file)"><i class="fa fa-paperclip"></i> Add Attachment</b-button>
              </b-row>
          </div>
      </b-modal>

  </div>
</template>
<style lang="scss">
  .list-of-mr {

    table {
      td:nth-child(1) {
        width: auto;
      }
      td:nth-child(2) {
        width: auto;
      }
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
  }

</style>
<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import task from "../apis/task";
import mr from "../apis/logistic_mr";
import dropdown from "../data/dropdown";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: { Loading},
  data() {
    return {
      actionHistoryShow:false,
      actionHistory:[],     
      showAttachment: false, 
      attachmens:[],
      showFilter: false,
      showDelConfirm: false,
      showApprovalConfirm: false,
      approvalHistory:[],
      file:null,
      confirmNoFile:false,
      showConfirmNoFile:'',
      showApprovalCancelConfirm: false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      model:{},
      items: [],
      tblData: {
        viewOption: 'Header',
        page: 1,
        limit: 15,
        total: 0,
        // tgl1:moment(this.$store.state.user.tglaktif,'YYYY-MM-DD').startOf('year').format('YYYY-MM-DD'),
        // tgl2:moment().format('YYYY-MM-DD'),        
        sortBy: 'requestdate',
        sortDesc: true,
        DimCol:'Dim1', createby: ''
      },
      user:this.$store.state.user,
      dataList: {
        openStatus: dropdown.openClose,
        approvalStatus: dropdown.approvalStatus,
        mrProgress: dropdown.mrProgress
      },      
      tblFields:[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "requestno",
            thStyle: "width:100px",
            label: "Request Number",
            sortable: true
          },
          {
            key: "requestdate",
            thStyle: "width:90px",
            label: "Request Date",
            sortable: true
          },
          {
            key: "createby",
            label: "Request By",
            sortable: true
          },
          {
            key: "expected",
            thStyle: "width:40px",
            label: "Expected/Due",
            sortable: true
          },
          {
            key: "locationdeliv",
            label: "Location Delivery",
            sortable: true
          },
          {
            key: "remark",
            label: "Remark",
            sortable: true
          },
          {
            key: "issuccess",
            label: "Approval Status",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "wfcomplete",
            thStyle: "width:90px",
            label: "Approval Date",
            sortable: true
          },
          {
            key: "actionstatus",
            label: "Action Status",
            sortable: true
          },
          {
            key: "prnumber",
            label: "Purchase Request",
            sortable: true
          },
        ]

    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
    "tblData.viewOption" : function(newval) {
      if (newval=='Header') {
        this.tblFields=[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "requestno",
            thStyle: "width:100px",
            label: "Request Number",
            sortable: true
          },
          {
            key: "requestdate",
            thStyle: "width:90px",
            label: "Request Date",
            sortable: true
          },
          {
            key: "createby",
            label: "Request By",
            sortable: true
          },
          {
            key: "expected",
            thStyle: "width:40px",
            label: "Expected/Due",
            sortable: true
          },
          {
            key: "locationdeliv",
            label: "Location Delivery",
            sortable: true
          },
          {
            key: "remark",
            label: "Remark",
            sortable: true
          },
          {
            key: "issuccess",
            label: "Approval Status",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "wfcomplete",
            thStyle: "width:90px",
            label: "Approval Date",
            sortable: true
          },
          {
            key: "actionstatus",
            label: "Action Status",
            sortable: true
          },
          {
            key: "prnumber",
            label: "Purchase Request",
            sortable: true
          },
        ];
      } else {
        this.tblFields= [
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "requestno",
            thStyle: "width:100px",
            label: "Request Number",
            sortable: true
          },
          {
            key: "requestdate",
            thStyle: "width:90px",
            label: "Request Date",
            sortable: true
          },
          {
            key: "createby",
            label: "Request By",
            sortable: true
          },
          {
            key: "itemname",
            label: "Request Item Name & Description",
            sortable: true
          },
          {
            key: "quantity",
            label: "Quantity",
            sortable: true
          },
          {
            key: "nilai",
            label: "Estimate Price",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "jasa",
            label: "Mtrl/Srvc",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "expected",
            thStyle: "width:40px",
            label: "Expected/Due",
            sortable: true
          },
          {
            key: "issuccess",
            label: "Approval Status",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "wfcomplete",
            thStyle: "width:90px",
            label: "Approval Date",
            sortable: true
          },
          {
            key: "actionstatus",
            label: "Action Status",
            sortable: true
          },
          {
            key: "prnumber",
            label: "Purchase Request",
            sortable: true
          },
        ];
      }
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          this.tblFields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      this.refresh();
    },

  },
  sockets: {
    task_changed: function(data) {
      const ada = this.items.find(i=> i.requestkey==data.taskkey);
      if (ada) {
        this.refresh();
      }
    }
  },
created: function(){
          const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          this.tblFields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }

},
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
   data: async function() {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.mrlistuser) {
            this.tblData[key] = filter.mrlistuser[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.mrlistuser.tgl1 || '';
          this.tblData.tgl2=filter.mrlistuser.tgl2 || '';
          this.showFilter=filtered;
          delete filter.mrlistuser;
          this.$store.commit("filter", filter);
        }
      if (this.user.group=='admin') {
        this.tblData.createby= '';
      } else {
        this.tblData.createby= this.user.username;
      } 
      this.isLoading=true;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      let list;
      if (this.tblData.createby){
         list = await mr.myrequest(this.tblData);    
      } else {
       list = await mr.list(this.tblData);    
      }
      this.items = list;  
      this.isLoading=false;
     return list;
    },
    search() {
      this.tblData.page=1;
      this.$refs.table.refresh();
    },
    refresh() {
      this.$refs.table.refresh();
    },
    clearFilter() {
        this.tblData.kodeaccc= '';
        this.tblData.jasa=  '';
        this.tblData.uraian=  '';
        this.tblData.requestno=  '';
        this.tblData.mrequestno=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
        this.tblData.outstand=  '';
        this.tblData.statuswf=  '';
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowAttachment(record) {
      this.model = record;
      this.getAttachment(record);
    },
    rowApproval(record) {
      this.rowClicked(record);
        this.approvalConfirm();        
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },
    saveFilter() {
      const keys = ['uraian', 'createby', 'nmcategory', 'jasa', 'requestno',  'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal','isproject', 'createby'];
      let filtered = false;
      const mrlist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              mrlist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          mrlist.viewOption=this.viewOption;
          mrlist.page=this.tblData.page;
          mrlist.limit=this.tblData.limit;
          mrlist.sortBy=this.tblData.sortBy;
          mrlist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.mrlistuser=mrlist;
          this.$store.commit("filter", filter);
      }
    },    

    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    add(){
      router.push({name :"app.requisitionfrm"});
    },
    edit: function() {
        if (this.model.requestkey) {
          router.push({name :'app.requisitionfrm', params: { requestkey: this.model.requestkey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.requestkey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      await mr.remove(this.model);
      this.refresh();
    },
    showActionHistory: async function(record) {
      try {
        this.model = record;
        this.isLoading=true;
        const data = await mr.actionhistory(record);
        this.actionHistory=data;    

        this.actionHistoryShow=true;            
        this.isLoading=false;
      } catch (error) {
        this.isLoading=false;
        if (error.message) {
            toastr.error(error.message,'ERROR MESSAGE',10000);
        } else {
            toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
        }                
      }

    },
    getAttachment: async function(record) {
      try {
        this.model = record;
        this.isLoading=true;
        const data = await task.getAttachment({taskkey: record.requestkey});
        this.attachmens=data;    
        this.showAttachment=true;            
        this.isLoading=false;
      } catch (error) {
        this.isLoading=false;
        console.log('error : ', error);
        if (error.sql) {
            toastr.error(error.sql,'ERROR MESSAGE',10000);
        } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
        } else if (error.message) {
            toastr.error(error.message,'ERROR MESSAGE',10000);
        } else {
            toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
        }   
      }
    },    
    attachmentSave : async function(evt) {
          evt.preventDefault()
          if (this.invalidFile) {
              console.log('validation : ', this.$v.file);
              console.log('model : ',this.file);
            //   this.showAddAttachment=true;
              toastr.error('Please choose a file');
        } else {
            toastr.info(`Attachment Save`);
            this.isLoading=true;
            try {
                const formData = new FormData();
                formData.append('file', this.file);
                formData.append('filename', this.file.name);
                formData.append('tablekey', this.model.requestkey);
                formData.append('tableName', 'mr_sr_header');
                const response = await task.attachmentSave(formData);
                console.log('response : ',response);
                const data = await task.getAttachment({taskkey: this.model.requestkey});
                this.attachmens=data;    
                this.file=null;
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
        }
    },   
    attachmentDownload : async function(fl) {
        this.isLoading=true;
        try {
            const response = await task.attachmentDownload(fl);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            console.log('error : ', error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }   
        }
    },      
    delAttachment : async function(obj) {
      const pesan=`Do You realy want to delete the attachment "${obj.attchFileNm}"?`;
      this.$bvModal.msgBoxConfirm(pesan, {
      title: 'Please Confirm',
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'success',
      okTitle: 'YES',
      cancelTitle: 'NO',
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true
      })
      .then(async(value) => {
          if (value==true){
              this.isLoading=true;
                try {
                    await task.delAttachment(obj);
                  const data = await task.getAttachment({taskkey: this.model.requestkey});
                  this.attachmens=data;    
                    this.isLoading=false;    
                } catch (error) {
                    this.isLoading=false;
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
                }
          }
              // this.close();
      })
      .catch(err => {
      // An error occurred
      })                

    },      

    approvalConfirm: async function () {
        if (this.model.requestkey) {
            if (this.model.send2wf==1) {
                    try {
                      const data = await task.approvalhistory({key: this.model.requestkey});
                      this.approvalHistory=data;                
                    } catch (error) {
                      if (error.message) {
                          toastr.error(error.message,'ERROR MESSAGE',10000);
                      } else {
                          toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                      }                
                    }
            }
            this.model.requestdate = this.model.requestdate ? moment(this.model.requestdate).format('YYYY-MM-DD') : '';
                this.showApprovalConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be sent to workflow Approval!');
        }
    }, 
    approval: async function(evt){
        evt.preventDefault()
        try {
            const formData = new FormData();
            if (!(this.file)) {
              if (this.confirmNoFile==false){
                toastr.info('Send without attachment, are you sure?');
                this.showConfirmNoFile=true;
                return;
              }
            } else {
              formData.append('file', this.file);
              formData.append('filename', this.file.name);
            }
            formData.append('tablekey', this.model.requestkey);
            this.showApprovalConfirm = false;
            this.isLoading=true;
            const resp = await mr.approval(formData);
            this.model.send2wf=1;
            this.file=null;
            this.refresh();
            this.isLoading=false;
            if (resp.message) {
                toastr.warn(resp.message,'warning',10000);
            }
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    approvalUndo: async function(){
        this.isLoading=true;
        try {
            await mr.approvalUndo(this.model);
            this.model.send2wf=0;
            this.showApprovalConfirm = false;
            this.refresh();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    printApproval: async function()
    {
      if (this.model.requestkey) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await task.approvalprint({key: this.model.requestkey});
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },      
    print: async function()
    {
      if (this.model.requestkey) {
          try {
                this.showReport=true;
              this.reportUrl= await mr.print(this.model);
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await mr.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    catalog(){
      router.push({name:"logistic.item_list"});
    }, 
     close(){
      router.push({name:"app.modules"});
    },       
  }
};
</script>
